
const style = {
  root: {
    tableLayout: 'fixed'
  },
}

export default style